<template>
  <div class="m-viewport" v-if="ready">
    <userinfo :login_flag="login" :info="ua"/>

    <div class="logos">
        <h2 class="logo_1"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
        <h2 class="logo_2"><a href="https://www.m3guo.com/activity/202309/preheat-lcoa/" target="_blank" rel="noopener noreferrer"></a></h2>            
    </div>    

    <div class="m-page-view" v-if="!lock">
      <div class="page-tab main-swiper">

        <!-- Add Pagination -->
        <div class="tab-hd" slot="pagination"></div>        

        <swiper ref="pageSwiper" :options="swiperOptions" class="swiper-body">
          <swiper-slide class="swiper-no-swiping">
            <pagemain ref="mainbody"/>
          </swiper-slide>
          <swiper-slide class="swiper-no-swiping">
            <rank/>
          </swiper-slide>
        </swiper>

      </div>

      <shop ref="shop"/>
    </div>
    <div class="m-lock" v-else>
      <p>活动9月1日10点开始，敬请期待</p>
    </div>

    <!-- <buyView/> -->
    <item-tips ref="tips"></item-tips>
  </div>
</template>

<script>
import userinfo from '@/components/userinfo'
import buyView from '@/components/buy'
import pagemain from '@/components/main'
import rank from '@/components/rank'
import shop from '@/components/shop'

export default {
  name: 'App',
  components: {
    userinfo,
    buyView,
    pagemain,
    rank,
    shop,
  },
  data (){
    return {
      swiperOptions : {
        pagination: {
          el: '.tab-hd',
          clickable: true,
          bulletClass: 'u-btn',
          bulletActiveClass: 'active',      
          renderBullet: function (index, className) {
            return '<div class="' + className + ' tab-' + (index + 1) + '"></div>';
          },
        },        
      },
      lock : false,
    }
  },
  props : {
      ready : {
          default : false,
      },
      login : {
          default : 0,
      },      
      ua : {
          default : () => [],
      },
      evt_info : {
          default : () => [],
      },                            
  },  
}
</script>

<style>
.m-viewport{
  position: relative;
    width: 750px;
    height: 5982px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/body.jpg);
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: top center;
    box-sizing: border-box;
    overflow-x: hidden;
    color: #876c4a;
    background-color: #720d0c;    
    padding-top: 1075px;
}

.logos{
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px; 
}

    
.logo_1{
    width: 163px;
    height: 130px;
    background-image: url(~@/assets/images/logo_main.png);
    transform: scale(0.8);
}

.logo_2{
    width: 114px;
    height: 136px;
    background-image: url(~@/assets/images/13logo.png);
    transform: scale(0.8);
}

.logos a{
    display: block;
    width: 100%;
    height: 100%;
}   

.m-lock{
  display: flex;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.m-page-view{

}

.swiper-body{
  margin-top: 45px;
}

.main-swiper{
  position: relative;
  margin-bottom: 0px;
}

.main-swiper::after{
    content: '';
    display: block;
    position: absolute;
    width: 142px;
    height: 117px;
    bottom: -23px;
    left: 0;
    background-image: url(~@/assets/images/layer-ck.png);
    pointer-events: none;
    z-index: 10;
    animation: npc 3s ease-out 2s infinite forwards;
}

.main-swiper::before{
    content: '';
    display: block;
    position: absolute;
    width: 663px;
    height: 991px;
    left: 50%;
    top: -915px;
    transform: translateX(-55%);
    background-image: url(~@/assets/images/layer-f.png);
    pointer-events: none;
    z-index: 10;
}


.main-swiper .tab-hd {
    display: flex;
    justify-content: space-between;
    /* padding: 0 16px; */
}

.main-swiper .tab-hd .u-btn{
    width: 370px;
    height: 102px;
    background-repeat: no-repeat;
}

.main-swiper .u-btn.tab-1 {
    background-image: url(~@/assets/images/btn-tab-1.png);
}

.main-swiper .u-btn.tab-1.active {
    background-image: url(~@/assets/images/btn-tab-1-active.png);
}

.main-swiper .u-btn.tab-2 {
    background-image: url(~@/assets/images/btn-tab-2.png);
}

.main-swiper .u-btn.tab-2.active {
    background-image: url(~@/assets/images/btn-tab-2-active.png);
}

@keyframes npc {
  0% {
    transform: translate3d(1rem, 0, 0)
  }

  30% {
    transform: translateZ(0)
  }

  40% {
    transform: translate3d(1rem, -.5rem, 0)
  }

  60% {
    transform: translate3d(-.3rem, -1rem, 0) rotate(20deg)
  }

  to {
    transform: translate3d(2rem, -1.5rem, 0)
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue